<div class="page-content-wrapper">
	<div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 mobile-view">
		<div class="inner-wrapper">
			<div class="sub-wrapper">
				<h3 class="page-title obs-card-title" style="text-align:center"><span class="page-sub-title">Confrim
						Visit</span></h3>
				<!-- <div class="section-wrapper">
                    <span class="section-title">Do you have any other members accompnaying you. Please add the details
                        in below form or else
                        click on confirm
                        button</span>
                    <div class="table-responsive margin-bottom-20 add-action-table">
                        <table align="center"
                            class="table table-bordered table-striped table-condensed tableheader table-red fix-tablelayout">
                            <!-- <thead>
                                <tr>
                                    <th>Employee Name</th>
                                    <th>Employee Email</th>
                                    <th>CompanyName</th>
                                    <th>Id Number</th>
                                    <th>Delete Action</th>
                                </tr>
                            </thead>
        <tbody>
          <tr *ngFor="let member of pobMembersList; let i = index">
            <td><label>Employee Name</label>
              <ara-textarea style="width: 120px" [sourceText]="member.PersonName" [maxLength]="1000" disabled="false"
                [rows]="1" (output)="getRemarks($event,'PersonName',i)"></ara-textarea>
            </td>
            <td>
              <label>Employee Email</label>
              <ara-textarea style="width: 120px" [sourceText]="member.Email" [maxLength]="1000" [rows]="1"
                disabled="false" (output)="getRemarks($event,'Email',i)">
              </ara-textarea>
              <!-- <div *ngIf="EmailId?.errors && (EmailId.dirty || EmailId.touched) ">
                                            <span class="error-msg-colour">
                                                <p *ngIf="EmailId?.errors.required">
                                                    <b>Email is required</b>
                                                </p>
                                                <p *ngIf="EmailId?.errors.emailvalidator">
                                                    <b>Please provide a valid email address</b>
                                                </p>
                                            </span>
                                        </div>
        </td>
        <td><label>Employee Company</label>
          <ara-textarea style="width: 120px" [sourceText]="member.Company" [maxLength]="1000" disabled="false"
            [rows]="1" (output)="getRemarks($event,'Company',i)"></ara-textarea>
        </td>
        <td>
          <label>Employee ID</label>
          <ara-textarea style="width: 120px" [sourceText]="member.Id" [maxLength]="1000" [rows]="1" disabled="false"
            (output)="getRemarks($event,'Id',i)">
          </ara-textarea>
        </td>
        <td>
          <label>Delete Member</label><br />
          <a (click)=" removeMemberFromList(i)">
            <i class="fa fa-trash"></i>
          </a>
        </td>
        </tr>
        </tbody>
        </table>
      </div>
      <a (click)=" addMember()" class="pull-right margin-top-10">
        <i class="fa fa-plus" aria-hidden="true" style="padding-right:6px;"></i>Add Member
      </a>
      <div class="clearfix"></div>
    </div> -->
				<p>Please confirm your pass request by clicking Confirm button below.</p>
				<footer>
					<a (click)="saveMemberDetails()" class="btn btn-primary primary-btn" role="button">
						Confirm
					</a>
				</footer>
			</div>
		</div>
	</div>
	<div class="clearfix"></div>
</div>
<ara-alerts [alertType]="alertType" [successDetails]="successDetails" [errorDetails]="errorDetails"
	(okClicked)="onOkClickedForConfirmation()" [confirmMessage]="confirmMessage"
	(yesClicked)="onYesClickedForConfirmation()" (noClicked)="onNoClickedForConfirmation()"></ara-alerts>